export enum IconColor {
  DARK = 'dark',
  INHERIT = 'inherit',
  LIGHT = 'light',
  MID = 'mid',
  PRIMARY = 'primary',
  WHITE = 'white',
  CONTEST = 'contest',
  ERROR = 'error',
  SUCCESS = 'success',
  RECRUITER_LIGHT = 'recruiter-light',
  PINK = 'pink',
  SEAFOAM = 'seafoam',
}

export enum HoverColor {
  CURRENT = 'currentColor',
  LIGHT = 'light',
  PRIMARY = 'primary',
}

export enum IconSize {
  XXLARGE = 'xxlarge',
  XLARGE = 'xlarge',
  LARGE = 'large',
  MID = 'mid',
  SMALL = 'small',
  XSMALL = 'xsmall',
}

export enum IconBackdrop {
  FREEMARKET = 'freemarket',
  PRIMARY = 'primary',
  PRIMARY_DARK = 'primary-dark',
  RECRUITER = 'recruiter',
  TERTIARY = 'tertiary',
  TRANSPARENT = 'transparent',
  WARRIOR_FORUM = 'warrior-forum',
  ERROR = 'error',
  SUCCESS = 'success',
  DARK = 'dark',
  WHITE = 'white',
}
